// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YQic9","newExpiryDate":"styles_newExpiryDate__1uf68","footer":"styles_footer__3hZR-"};